var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content article-item"},[(_vm.imgSrc)?_c('img',{staticClass:"a-img",attrs:{"src":_vm.imgSrc}}):_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingFile),expression:"loadingFile"}],staticClass:"a-img"},[_vm._v("未选择图片")]),_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.articleData.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }